import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiTypography']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => {
    const colorValue =
      theme.vars.palette[ownerState.color as keyof typeof theme.vars.palette];

    return {
      ...(ownerState.color === 'textHeader' && {
        color: theme.vars.palette.text.header,
      }),
      ...(colorValue &&
        typeof colorValue === 'object' &&
        'main' in colorValue && {
          color: colorValue.main,
        }),
      ...(typeof colorValue === 'string' && {
        color: colorValue,
      }),
    };
  },
};

const MuiTypography: Components<CssVarsTheme>['MuiTypography'] = {
  styleOverrides,
};

export default MuiTypography;
